export class ActualJobs {
  public existingEmployees?: number;
  public constructionLabor?: number;
}